import React, {
  useEffect,
  useState
} from 'react'

import { defaultTimezone } from '../DateTime/helper'
import { ITimeZoneStandard } from '../DateTime/interfaces'
import DSTTimeZoneList from '../DateTime/TimeZoneList'
import Dropdown from '../DropDown/Dropdown'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'

const TimeZoneStandard: React.FunctionComponent<ITimeZoneStandard> = (props) => {
  const { zone, onChange, dstZone, disableTzDropdown, version, timezoneWidth, dropdownPortalProps, isUsingUserTimezone, onUseUserTimezoneChange, hasUserTimezoneCheckBox } = props
  const propsZone = dstZone

  let DSTTZList = DSTTimeZoneList()
  let defaultTZ = zone ? defaultTimezone(zone) : defaultTimezone('')
  let zoneObj: any

  if (dstZone) {
    let idx = DSTTZList.findIndex((singleTZObj) => singleTZObj.value === dstZone)
    if (typeof idx !== 'undefined' && DSTTZList[idx]) {
      DSTTZList[idx].default = true
    }
    zoneObj = DSTTZList[idx]
  } else {
    let idx = DSTTZList.findIndex((singleTZObj) => singleTZObj.value === defaultTZ)
    if (typeof idx !== 'undefined' && DSTTZList[idx]) {
      DSTTZList[idx].default = true
    }
    zoneObj = DSTTZList[idx]
  }
  const [currZoneObj, setCurrZoneObj] = useState(zoneObj)

  const zoneHandler = (value: any) => {
    let valObj = { ...value }
    if (!valObj) {
      valObj = {}
    }
    let val: any = valObj.value ? valObj.value : ''
    onChange(val, valObj)
  }

  useEffect(() => {
    if (dstZone) {
      let idx = DSTTZList.findIndex((singleTZObj) => singleTZObj.value === dstZone)
      if (typeof idx !== 'undefined' && DSTTZList[idx]) {
        DSTTZList[idx].default = true
      }
      setCurrZoneObj(DSTTZList[idx])
      zoneHandler({ ...DSTTZList[idx] })
    } else {
      let idx = DSTTZList.findIndex((singleTZObj) => singleTZObj.value === defaultTZ)
      if (typeof idx !== 'undefined' && DSTTZList[idx]) {
        DSTTZList[idx].default = true
      }
      setCurrZoneObj(DSTTZList[idx])
      zoneHandler({ ...DSTTZList[idx] })
    }
  }, [propsZone])

  let dropdownOptions = [...DSTTZList];

  if (hasUserTimezoneCheckBox) {
    const useUserTimezoneOption = {
      label:
        <ToggleSwitch
          checked={isUsingUserTimezone}
          label="Use user's timezone"
          labelColor="primary"
          labelPosition="right"
          onChange={(value) => {
            onUseUserTimezoneChange(value);
          }}
          onClick={() => undefined}
        />,
      value: 'useUsersTimezone',
      disable: true
    }
    if (!isUsingUserTimezone) {
      dropdownOptions = [useUserTimezoneOption, ...dropdownOptions]
    } else {
      dropdownOptions = [useUserTimezoneOption]
    }
  }

  const dropdownPlaceholder = isUsingUserTimezone ? "User's Timezone" : 'Choose Time Zone'

  return (
    <div>
      <Dropdown
        list={dropdownOptions}
        type="select"
        viewAs="label"
        title="Choose Time Zone"
        searchPlaceholder={'Search time zone'}
        emptyPlaceholder={dropdownPlaceholder}
        dropDownType={version && version === "v2" ? "primary" : "tertiary"}
        withSearch={true}
        isSearchDisabled={isUsingUserTimezone}
        onChange={zoneHandler}
        closeAfterSelect={true}
        arrowSecondary={true}
        isDisabled={disableTzDropdown}
        testId="cs-time-picker-select-zone"
        version={version && version === "v2" ? 'v2' : 'v1'}
        style={timezoneWidth ? { width: `${timezoneWidth}px` } : undefined}
        {...dropdownPortalProps}
      />
    </div>
  )
}

export default TimeZoneStandard
